var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodatanotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.959,
    height: 109.313,
    viewBox: "0 0 115.959 109.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Push_notifications-rafiki",
    "data-name": "Push notifications-rafiki",
    transform: "translate(-51.11 -62.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1",
    transform: "translate(58.763 62.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M138.16,89.362C125.262,79.141,117.619,67.433,101.8,63.1c-13.229-3.621-19.844,2.018-23.325,12.32-8.534,25.385,14.964,53.375,43.468,65.252,26.988,11.253,48.443,2.171,54.61-20.035,2.335-8.391,2.123-23.011-11.692-27.128C154.72,90.483,149.158,98.069,138.16,89.362Z",
    transform: "translate(-76.703 -62.004)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M138.16,89.362C125.262,79.141,117.619,67.433,101.8,63.1c-13.229-3.621-19.844,2.018-23.325,12.32-8.534,25.385,14.964,53.375,43.468,65.252,26.988,11.253,48.443,2.171,54.61-20.035,2.335-8.391,2.123-23.011-11.692-27.128C154.72,90.483,149.158,98.069,138.16,89.362Z",
    transform: "translate(-76.703 -62.004)",
    fill: "#fff",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1",
    transform: "translate(51.11 164.548)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 57.98,
    cy: 3.385,
    rx: 57.98,
    ry: 3.385,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1",
    transform: "translate(101.548 78.073)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_725",
    "data-name": "Rectangle 725",
    width: 1.764,
    height: 0.299,
    transform: "translate(46.24 17.314) rotate(-86.3)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_726",
    "data-name": "Rectangle 726",
    width: 5.798,
    height: 0.299,
    transform: "translate(46.435 14.189) rotate(-86.31)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M263.038,115.74H227.886a3.63,3.63,0,0,0-3.556,3.346l-4.542,70.123a3.11,3.11,0,0,0,3.131,3.349h35.145a3.636,3.636,0,0,0,3.564-3.349l4.539-70.123a3.107,3.107,0,0,0-3.131-3.346Z",
    transform: "translate(-219.779 -115.739)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M261.922,115.74H227.886a3.63,3.63,0,0,0-3.556,3.346l-4.542,70.123a3.11,3.11,0,0,0,3.131,3.349h34.03a3.636,3.636,0,0,0,3.564-3.349l4.539-70.123a3.107,3.107,0,0,0-3.131-3.346Z",
    transform: "translate(-219.779 -115.739)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M260.947,201.76H223.508a1.023,1.023,0,0,1-1.023-1.089l4.109-63.455a1.023,1.023,0,0,1,1.02-.957h37.442a1.026,1.026,0,0,1,1.023,1.091L261.969,200.8A1.023,1.023,0,0,1,260.947,201.76Z",
    transform: "translate(-221.674 -130.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M290.194,126.775H276.585a.505.505,0,0,1-.508-.544h0a.6.6,0,0,1,.577-.541h13.609a.5.5,0,0,1,.508.541h0A.6.6,0,0,1,290.194,126.775Z",
    transform: "translate(-259.241 -122.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M281.512,361.091a1.42,1.42,0,0,1-1.4,1.334,1.256,1.256,0,0,1-1.265-1.334,1.42,1.42,0,0,1,1.4-1.331,1.253,1.253,0,0,1,1.265,1.331Z",
    transform: "translate(-261.18 -286.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M257.763,195h-31.97l-2.033,31.369h34a3.355,3.355,0,0,0,3.349-3.346V198.358A3.355,3.355,0,0,0,257.763,195Z",
    transform: "translate(-222.57 -171.298)",
    fill: "#ce8045",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notification--inject-1",
    transform: "translate(88.298 96.472)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_727",
    "data-name": "Rectangle 727",
    width: 45.878,
    height: 31.372,
    rx: 11.2,
    transform: "translate(2.937 2.524)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M179.751,181.84a.3.3,0,0,1-.209-.087l-.538-.535a.3.3,0,1,1,.425-.425l.535.538a.3.3,0,0,1-.212.508Z",
    transform: "translate(-177.885 -179.678)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M176.526,189.378h-.757a.3.3,0,1,1,0-.6h.757a.3.3,0,0,1,0,.6Z",
    transform: "translate(-175.47 -185.338)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M187.251,178.623a.3.3,0,0,1-.3-.278l-.054-.757a.3.3,0,1,1,.6-.042l.057.757a.3.3,0,0,1-.278.32Z",
    transform: "translate(-183.48 -177.268)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M273.19,279.83l12.03,12.027V279.83Z",
    transform: "translate(-243.968 -249.161)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M243.957,219.224l-.6-2.539a4.593,4.593,0,0,1,0-2.027l.831-3.615a7.09,7.09,0,0,0-3.75-7.868,2.019,2.019,0,0,0,.069-.2,1.711,1.711,0,1,0-3.34-.748,1.287,1.287,0,0,0-.027.212,7.093,7.093,0,0,0-6.749,5.514l-.81,3.618a4.567,4.567,0,0,1-.867,1.827l-1.612,2.048a1.513,1.513,0,0,0,.858,2.41l14.2,3.182a1.51,1.51,0,0,0,1.791-1.812Z",
    transform: "translate(-211.437 -193.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M246.433,264.793a.673.673,0,0,0-.807.775,2.455,2.455,0,0,0,4.435.993.673.673,0,0,0-.4-1.044Z",
    transform: "translate(-224.64 -238.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M207.208,216.169a.443.443,0,0,1-.374-.2,9.593,9.593,0,0,1,2.652-13.3.449.449,0,0,1,.5.748,8.7,8.7,0,0,0-2.392,12.06.449.449,0,0,1-.123.622A.455.455,0,0,1,207.208,216.169Z",
    transform: "translate(-196.323 -195.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M214.469,219.337a.449.449,0,0,1-.371-.2A7.311,7.311,0,0,1,216.117,209a.45.45,0,0,1,.5.748,6.408,6.408,0,0,0-1.773,8.887.449.449,0,0,1-.123.622A.461.461,0,0,1,214.469,219.337Z",
    transform: "translate(-201.685 -199.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M221.73,222.543a.443.443,0,0,1-.371-.2,5.018,5.018,0,0,1,1.393-6.965.449.449,0,0,1,.5.745,4.124,4.124,0,0,0-1.139,5.721.447.447,0,0,1-.383.7Z",
    transform: "translate(-207.044 -203.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M297.3,238.043a.449.449,0,0,1-.206-.846,8.7,8.7,0,0,0,3.738-11.716.449.449,0,1,1,.8-.41A9.593,9.593,0,0,1,297.5,238a.472.472,0,0,1-.194.048Z",
    transform: "translate(-260.556 -210.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M293.791,238.535a.449.449,0,0,1-.206-.846,6.405,6.405,0,0,0,2.754-8.636.449.449,0,1,1,.8-.413,7.3,7.3,0,0,1-3.14,9.844A.431.431,0,0,1,293.791,238.535Z",
    transform: "translate(-258.095 -213.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M290.289,238.965a.452.452,0,0,1-.206-.849,4.118,4.118,0,0,0,1.773-5.553.449.449,0,0,1,.8-.413,5.027,5.027,0,0,1-2.165,6.764A.458.458,0,0,1,290.289,238.965Z",
    transform: "translate(-255.643 -215.568)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1",
    transform: "translate(62.873 69.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M196.312,125.85h-2.285a.251.251,0,0,0-.242.215l-.478,4.557a.194.194,0,0,0,.194.218h2.285a.251.251,0,0,0,.242-.218l.478-4.557a.191.191,0,0,0-.194-.215Z",
    transform: "translate(-162.547 -113.835)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M196.105,125.847h-2.078a.251.251,0,0,0-.242.215l-.478,4.557a.194.194,0,0,0,.194.218h2.093a.248.248,0,0,0,.239-.218l.478-4.557a.188.188,0,0,0-.206-.215Z",
    transform: "translate(-162.547 -113.832)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M163.245,406.28a.977.977,0,0,0,.7-.182.221.221,0,0,0,0-.251.317.317,0,0,0-.188-.135c-.407-.111-1.232.374-1.268.395a.054.054,0,0,0-.024.057.06.06,0,0,0,.048.048A4.354,4.354,0,0,0,163.245,406.28Zm.365-.469a.433.433,0,0,1,.111,0,.2.2,0,0,1,.117.081c.042.072.03.108,0,.126-.1.158-.718.161-1.169.1a2.455,2.455,0,0,1,.942-.3Z",
    transform: "translate(-140.929 -309.997)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M162.47,404.863h.024c.3-.132.843-.655.786-.93,0-.063-.063-.144-.221-.158a.416.416,0,0,0-.314.1,1.556,1.556,0,0,0-.335.933.063.063,0,0,0,.027.054A.06.06,0,0,0,162.47,404.863Zm.55-.981h.033c.1,0,.114.051.114.063.036.164-.341.577-.631.757a1.3,1.3,0,0,1,.3-.748A.3.3,0,0,1,163.02,403.882Z",
    transform: "translate(-140.89 -308.649)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_728",
    "data-name": "Rectangle 728",
    width: 2.422,
    height: 5.607,
    transform: "translate(18.912 90.55)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M94.95,385.532l2.419.263,1.576-5.442-2.419-.263Z",
    transform: "translate(-93.603 -292.049)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M105.041,399.833a.96.96,0,0,0,.733,0,.212.212,0,0,0,.048-.245.3.3,0,0,0-.15-.173c-.374-.206-1.3.054-1.34.063a.057.057,0,0,0-.042.051.063.063,0,0,0,.036.057,4.442,4.442,0,0,0,.715.248Zm.472-.359a.476.476,0,0,1,.1.039.188.188,0,0,1,.1.1.205.205,0,0,1,0,.129c-.144.123-.745-.024-1.172-.2a2.518,2.518,0,0,1,.972-.072Z",
    transform: "translate(-100.15 -305.538)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M104.327,398.007h.024c.3-.057.987-.422,1-.7,0-.066-.024-.156-.176-.209a.428.428,0,0,0-.332.018c-.353.17-.55.786-.559.81a.057.057,0,0,0,0,.057A.051.051,0,0,0,104.327,398.007Zm.777-.8h.036c.1.036.1.078.1.09,0,.167-.478.469-.807.568a1.271,1.271,0,0,1,.466-.643.3.3,0,0,1,.209-.015Z",
    transform: "translate(-100.139 -303.955)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M94.34,396.619l-2.646-.76a.2.2,0,0,0-.239.1L90.48,397.9a.368.368,0,0,0,.242.511c.927.248,1.391.326,2.554.658.715.206,2.171.7,3.161.987s1.355-.646.972-.849a6.4,6.4,0,0,1-2.721-2.329A.619.619,0,0,0,94.34,396.619Z",
    transform: "translate(-90.445 -303.097)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M154.125,406.29h-2.643a.2.2,0,0,0-.2.167L150.9,408.6a.374.374,0,0,0,.368.434c.954-.018,2.329-.075,3.529-.075,1.4,0,2.168.078,3.813.078.993,0,1.226-1,.8-1.1-1.911-.413-3.014-.458-4.695-1.468a1.2,1.2,0,0,0-.592-.176Z",
    transform: "translate(-132.818 -310.414)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_729",
    "data-name": "Rectangle 729",
    width: 2.422,
    height: 2.892,
    transform: "translate(18.912 90.55)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M98.313,380.1l2.419.26-.876,3.02L97.5,382.9Z",
    transform: "translate(-95.39 -292.056)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M111.151,202s-1.337,18.283-2.533,25.215c-1.319,7.592-8.992,30.839-8.992,30.839l-4.4-.8s5.541-21.829,6.154-29.347c.667-8.158,1.468-24.972,1.468-24.972Z",
    transform: "translate(-93.799 -167.213)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M138.858,226.58c.239-1,.789.26,1.429,2.452-.484,5.424-1.115,11.707-1.719,15.17-.135.774-.338,1.713-.6,2.778C138.2,239.241,138.209,229.3,138.858,226.58Z",
    transform: "translate(-123.759 -184.198)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M143.9,200.34s1.755,18.379,1.815,25.762c.063,7.682-1.519,32.831-1.519,32.831h-4.106s-1.232-24.7-1.743-32.245c-.559-8.223-2.913-25.418-2.913-25.418Z",
    transform: "translate(-121.978 -166.05)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M99.787,382.663c.018,0-.691,1.594-.691,1.594l-4.946-.9.3-1.48Z",
    transform: "translate(-93.042 -293.303)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M154.59,390.81c.018,0-.158,1.7-.158,1.7h-4.988l-.2-1.519Z",
    transform: "translate(-131.658 -299.563)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M105.015,139.51c-.329.637-.691,1.307-1.02,1.968l-1,1.992c-.326.664-.646,1.331-.954,2s-.6,1.331-.846,1.995l-.024-1.047a12.959,12.959,0,0,0,.628,1.573c.117.263.266.514.395.774s.3.508.452.754a17.3,17.3,0,0,0,1.029,1.468c.185.236.371.478.568.706s.413.464.6.658l.06.066a.861.861,0,0,1-1.059,1.331,9.855,9.855,0,0,1-.9-.571,10.37,10.37,0,0,1-.831-.622,14.291,14.291,0,0,1-1.513-1.438,13.1,13.1,0,0,1-1.3-1.681,12.858,12.858,0,0,1-1.035-1.908,1.289,1.289,0,0,1-.063-.9l.042-.141c.227-.781.481-1.537.763-2.279s.58-1.468.9-2.183.649-1.42,1-2.117.7-1.379,1.106-2.075a1.734,1.734,0,1,1,3.044,1.663Z",
    transform: "translate(-95.842 -121.601)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M108.572,135.322c.12,2.282-2.47,6.471-2.47,6.471l-5.332-2.664a15.7,15.7,0,0,1,2.954-5.152C106.544,130.86,108.461,133.229,108.572,135.322Z",
    transform: "translate(-97.683 -118.477)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M114.78,188.836l1.074,1.794,2.234-1.429a3.618,3.618,0,0,0-1.737-1.564.748.748,0,0,0-.9.38Z",
    transform: "translate(-107.503 -157.12)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M119.264,195.18l1.038-.194a.673.673,0,0,0,.538-.789L120.6,193l-2.234,1.429.15.362A.67.67,0,0,0,119.264,195.18Z",
    transform: "translate(-110.02 -160.905)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M142.42,102.783c.021.194.144.347.269.335s.209-.176.185-.371-.144-.347-.269-.338S142.4,102.586,142.42,102.783Z",
    transform: "translate(-126.875 -97.403)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M142.85,104.82a7.523,7.523,0,0,0,1.121,1.6,1.074,1.074,0,0,1-.9.248Z",
    transform: "translate(-127.179 -99.094)",
    fill: "#ff5652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M139.386,99.06a.1.1,0,0,0,.087-.027.867.867,0,0,1,.786-.212.108.108,0,0,0,.138-.078.12.12,0,0,0-.081-.144,1.1,1.1,0,0,0-1,.257.114.114,0,0,0,0,.164A.1.1,0,0,0,139.386,99.06Z",
    transform: "translate(-124.678 -94.712)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M122.27,110.9c.571,1.731,1.331,4.922.248,6.2,0,0,.712,1.743,3.989,1.465,3.609-.3,1.5-1.929,1.5-1.929-2.027-.3-2.165-1.761-2-3.158Z",
    transform: "translate(-112.753 -103.355)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M119.52,129.429c-.338-.541-.715-1.16-.075-1.391a19.222,19.222,0,0,1,6.055-.32c1.405.347,1.118,1.5,1.118,1.5Z",
    transform: "translate(-110.53 -115.051)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M152.351,135.129c.514.472,1.071,1,1.624,1.474s1.112.969,1.675,1.441,1.136.918,1.713,1.352,1.163.828,1.749,1.2l-1.2-.114a4.465,4.465,0,0,0,1.391-.643,9.115,9.115,0,0,0,1.37-1.175,15.79,15.79,0,0,0,1.259-1.456c.2-.26.4-.523.6-.8s.377-.559.541-.81l.033-.048a.864.864,0,0,1,1.552.718c-.114.389-.233.721-.371,1.068s-.281.688-.443,1.023a13.818,13.818,0,0,1-1.145,1.959,10.257,10.257,0,0,1-1.585,1.794,6.992,6.992,0,0,1-2.258,1.352,1.429,1.429,0,0,1-1.1-.063l-.1-.051a21.55,21.55,0,0,1-2.159-1.22c-.679-.44-1.337-.9-1.971-1.388s-1.247-.987-1.845-1.5-1.172-1.041-1.755-1.636a1.734,1.734,0,0,1,2.407-2.494Z",
    transform: "translate(-131.803 -120.022)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M123.742,130.348s3.014,2.925,3.364,21.013a37.9,37.9,0,0,1-13.041,1.145,88.745,88.745,0,0,0-2.727-18.45,2.623,2.623,0,0,1,2.03-3.289c.458-.09.939-.17,1.417-.233a47.667,47.667,0,0,1,5.484-.464,24.286,24.286,0,0,1,3.472.278Z",
    transform: "translate(-105.021 -116.793)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M145.147,134.057c.3,2.264,4.186,6.615,4.186,6.615l4.614-4.785a37.859,37.859,0,0,0-4.432-3.974C146.134,129.386,144.878,131.958,145.147,134.057Z",
    transform: "translate(-128.765 -117.35)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M195.792,134.893l1.543-1.414-1.848-1.9a3.618,3.618,0,0,0-1.2,2.015.748.748,0,0,0,.568.8Z",
    transform: "translate(-163.235 -117.851)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M200.688,131.2l-.4-.978a.676.676,0,0,0-.9-.368l-1.133.475,1.848,1.9.323-.218a.673.673,0,0,0,.257-.81Z",
    transform: "translate(-166.02 -116.605)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M120.594,95.1c.434,2.392.565,3.81,1.911,4.949a3.069,3.069,0,0,0,5.084-2.063c.251-2.2-.5-5.744-2.934-6.516A3.117,3.117,0,0,0,120.594,95.1Z",
    transform: "translate(-111.538 -89.616)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M118.4,92.012c.84.191,1.5-.78,1.585-1.056a2.077,2.077,0,0,1-1.28-.356c.449.039.882-.514.936-.727a1.866,1.866,0,0,1-1.175-.763,1.537,1.537,0,0,0,.8-2.44c-.8-1.145-4.136-.185-4.605-1-.7.407-.078.948-.078.948s-4.722.9-2.545,2.718c-1.6.144-1.821,2.03-.49,2.99s1.4,1.594.87,1.516c.212.407,1.16.461,1.214.066A2.128,2.128,0,0,0,116,95.676C117.486,95.493,118.945,93.409,118.4,92.012Z",
    transform: "translate(-104.632 -85.67)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M112.133,94.568c-1.124.155-1.636-.478-1.355-1.038C109.385,94.242,110.907,95.815,112.133,94.568Z",
    transform: "translate(-104.309 -91.18)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M132.489,103.369a2.632,2.632,0,0,0,.981,1.232c.6.395,1.139,0,1.038-.6-.093-.55-.514-1.42-1.136-1.576a.712.712,0,0,0-.882.942Z",
    transform: "translate(-119.881 -97.391)",
    fill: "#ff8b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1",
    transform: "translate(148.288 137.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M381.838,361.461c-2.213-5.221-3.107-11.363-.574-11.109,2.6.251,2.294,9.509,2.715,10.526A3.3,3.3,0,0,1,381.838,361.461Z",
    transform: "translate(-378.639 -339.575)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M385.521,354.39c-.544,1.992-1.121,5.069-1.561,7.676.251.748.535,1.5.843,2.231a3.313,3.313,0,0,0,2.144-.583C386.612,362.912,386.732,356.98,385.521,354.39Z",
    transform: "translate(-381.605 -342.411)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M388.9,335.259c-.694-11.094,1.2-21.378,6.172-20.914,4.27.4-1.956,19.078-1.836,21.231A6.46,6.46,0,0,1,388.9,335.259Z",
    transform: "translate(-384.967 -314.33)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M400,349.421c.78-7.975,4.988-17.281,6.794-14.171,2.294,3.947-3.588,13.349-3.747,14.895A4.659,4.659,0,0,1,400,349.421Z",
    transform: "translate(-392.848 -328.563)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M395.6,319.951a.782.782,0,0,1-.754-.843c.036-.5.449-1,.831-1.008.185,0,.5.1.574.786l-.3.036c-.036-.329-.135-.523-.266-.523h0c-.2,0-.514.371-.538.73-.021.3.147.466.5.526Z",
    transform: "translate(-389.232 -316.973)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M412.982,327.083a1.134,1.134,0,0,1-.6-.23l.161-.248c.278.179.493.227.577.126a.833.833,0,0,0-.221-.882c-.209-.2-.455-.185-.727.054l-.194-.227a.78.78,0,0,1,1.127-.042,1.077,1.077,0,0,1,.248,1.283A.442.442,0,0,1,412.982,327.083Z",
    transform: "translate(-401.246 -322.098)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M388.911,341.8a.745.745,0,0,1-.783-.6,1.078,1.078,0,0,1,.484-1.214c.17-.057.5-.063.786.574l-.275.126c-.135-.3-.3-.461-.416-.416a.851.851,0,0,0-.3.858c.069.3.3.4.64.347l.045.3A1.073,1.073,0,0,1,388.911,341.8Z",
    transform: "translate(-384.504 -332.296)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M378.323,362.613a.724.724,0,0,1-.685-.446,1.085,1.085,0,0,1,.245-1.286c.158-.09.481-.155.882.419l-.245.17c-.191-.272-.374-.395-.487-.329a.827.827,0,0,0-.123.9c.123.266.356.338.694.218l.1.284A1.113,1.113,0,0,1,378.323,362.613Z",
    transform: "translate(-377.101 -346.92)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M396.623,332.594a.155.155,0,0,1-.087-.027.879.879,0,0,1-.395-1.085,1.008,1.008,0,0,1,1.044-.6c.185.033.619.2.649.993a.15.15,0,0,1-.3,0c-.018-.416-.158-.667-.4-.712a.718.718,0,0,0-.715.428c-.108.254,0,.511.3.724a.15.15,0,0,1-.087.272Z",
    transform: "translate(-390.103 -325.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M407.664,359.5a.144.144,0,0,1-.144-.12.146.146,0,0,1,.114-.176c.407-.084.631-.266.637-.514a.721.721,0,0,0-.541-.634c-.269-.066-.508.081-.667.41a.15.15,0,1,1-.269-.132.9.9,0,0,1,1-.571,1.017,1.017,0,0,1,.771.93c0,.188-.1.643-.873.8Z",
    transform: "translate(-397.6 -344.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M422.251,350.979c-.173,0-.4-.1-.661-.487l.248-.167c.185.275.362.4.478.338a.8.8,0,0,0,.141-.9c-.114-.266-.347-.344-.688-.233l-.093-.284a.789.789,0,0,1,1.056.4,1.075,1.075,0,0,1-.272,1.277A.415.415,0,0,1,422.251,350.979Z",
    transform: "translate(-407.982 -338.764)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M389.462,381.652a6.648,6.648,0,0,0-1.612-4.348.434.434,0,0,0,.371-.425.443.443,0,0,0-.443-.44H377.766a.437.437,0,0,0-.066.867,6.674,6.674,0,0,0,1.947,10.26.484.484,0,0,0,.224.915h5.8a.485.485,0,0,0,.224-.915A6.686,6.686,0,0,0,389.462,381.652Z",
    transform: "translate(-376.084 -357.867)",
    fill: "#263238"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodatanotification);
export default __webpack_public_path__ + "static/media/nodatanotification.0553f28a6c920db78d0e99bd0fa3ede4.svg";
export { ForwardRef as ReactComponent };